import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import TextLabel from '../textLabel/textLabel';
import Button from '../button/button';
import { stackTypes } from './constants';
var GalleryCard = function GalleryCard(_ref) {
  var dataHook = _ref.dataHook,
    title = _ref.title,
    onClick = _ref.onClick,
    backgroundImage = _ref.backgroundImage,
    width = _ref.width,
    height = _ref.height,
    mainButton = _ref.mainButton,
    secondaryButton = _ref.secondaryButton,
    stackType = _ref.stackType,
    titleSuffix = _ref.titleSuffix,
    children = _ref.children,
    getClassName = _ref.getClassName;
  var mainClickAction = mainButton && mainButton.handler || onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName('control-gallery-card-wrapper'),
    "data-hook": dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames('gallery-card', {
      clickable: Boolean(mainClickAction)
    }),
    style: {
      width: width,
      height: height,
      backgroundImage: backgroundImage && "url(".concat(backgroundImage, ")")
    },
    onClick: mainClickAction
  }, children && /*#__PURE__*/React.createElement("div", {
    className: "gallery-card-children"
  }, " ", children), stackType === stackTypes.MULTIPLE && /*#__PURE__*/React.createElement("div", {
    className: "stacked-cards"
  }), /*#__PURE__*/React.createElement("div", {
    className: classnames('gallery-card-title-container', {
      'title-suffix-only': !title && titleSuffix,
      'displayed-with-stacked': stackType === stackTypes.MULTIPLE
    })
  }, title && /*#__PURE__*/React.createElement("div", {
    className: classnames('gallery-card-title', {
      'has-suffix': titleSuffix
    })
  }, _.isString(title) ? /*#__PURE__*/React.createElement(TextLabel, {
    type: "T07",
    value: title
  }) : title), /*#__PURE__*/React.createElement("div", {
    className: "gallery-card-title-suffix"
  }, titleSuffix)), mainButton && /*#__PURE__*/React.createElement("div", {
    className: "gallery-card-button-overlay"
  }, /*#__PURE__*/React.createElement(Button, {
    dataHook: "main-button",
    onClick: function onClick(e) {
      e.stopPropagation();
      mainButton.handler();
    }
  }, mainButton.title), secondaryButton && /*#__PURE__*/React.createElement("div", {
    className: "gallery-card-secondary-button"
  }, /*#__PURE__*/React.createElement(Button, {
    dataHook: "secondary-button",
    className: "btn-confirm-secondary",
    onClick: function onClick(e) {
      e.stopPropagation();
      secondaryButton.handler();
    }
  }, secondaryButton.title)))));
};
GalleryCard.displayName = displayNames.GALLERY_CARD;
GalleryCard.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Main title for the gallery card as a string or node */
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  /** Function to be executed on gallery card click */
  onClick: PropTypes.func,
  /** URL for background image of gallery card */
  backgroundImage: PropTypes.string,
  /** Main button properties: handler and title */
  mainButton: PropTypes.shape({
    handler: PropTypes.func,
    title: PropTypes.string
  }),
  /** Secondary button properties: handler and title */
  secondaryButton: PropTypes.shape({
    handler: PropTypes.func,
    title: PropTypes.string
  }),
  /** width of gallery card */
  width: PropTypes.string,
  /** height of gallery card */
  height: PropTypes.string,
  /** Show a visual illusion of multiple cards stacked */
  stackType: PropTypes.oneOf([stackTypes.SINGLE, stackTypes.MULTIPLE]),
  /** Title suffix node, usually used for info icon or similar actions */
  titleSuffix: PropTypes.node
};
GalleryCard.defaultProps = {
  stackType: stackTypes.SINGLE
};
export default compose(GalleryCard);